import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import CheckoutPage from "./pages/checkout/checkout.component";
import AboutUsPage from "./pages/aboutUs/aboutUs.page";
import AgencyPage from "./pages/agency/agency.page";
import AccessoriesPage from "./pages/accessories/accessories.page";
import ProductPage from "./pages/product/product.page";
import EducationPage from "./pages/education/education.page";
import Page404 from "./pages/404page/404page.page";
import DownloadPage from "./pages/downloadFile/download.page";
import LogInPage from "./pages/logIn/logIn.page";
import ProfilePage from "./pages/profile/profile.page";
import AgenciesPage from "./pages/agencies/agencies.page";
import ContactPage from "./pages/contact/contact.page";
import SuggestionPage from "./pages/suggestion/suggestion.page";
import Home from "./pages/home/home.component";
import RepresentationPage from "./pages/representation/representation.page";
import FaqPage from "./pages/faq/faq.page";
import SingleProductPage from "./pages/singleProduct/singleProduct.page";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
	selectActiveLink,
	selectBaseInfo,
	selectLoaded,
	selectNearest,
	selectSelectedProduct,
} from "./redux/site/site.selector";
import { selectProduct } from "./redux/users/users.selector";
import {
	ChangeActiveLink,
	SetApplication,
	SetBaseInfo,
	SetNews,
	SetSlider,
} from "./redux/site/site.actions";
import SingleNews from "./pages/singleNews/singleNews.page";
import SingleNewsLayout from "./layouts/singleNews/singleNews.layout";
import TermsPage from "./pages/terms/terms.page";
import SpecialFeaturesPage from "./pages/specialFeatures/specialFeatures.page";
import Axios from "axios";
import { Alert } from "rsuite";
import { Setting } from "./setting";
import MapPage from "./pages/map/map.page";
import CallBackPage from "./pages/callBack/callBack.page";
import OnlinePayPage from "./pages/onlinePay/onlinePay.page";
import { withRouter } from "react-router-dom";
import axios from "axios";

const reverse = require("reverse-geocode");

class App extends Component {
	componentDidMount() {
		const {
			setBaseInfo,
			setApplication,
			setNews,
			SetSlider,
			history,
			changeActive,
		} = this.props;
		// this.fetchChat();

		const successfulLookup = (position) => {
			const { latitude, longitude } = position.coords;

			return null;
		};

		Axios.get(`${Setting.apiUrl}api/contactUs/list`)
			.then((res) => {
				if (res.status === 200) {
					setBaseInfo(res.data.data);
				} else {
					Alert.error(
						"برخی از اطلاعات قادر به بارگذاری نیست، همکاران ما درحال برسی هستند، از شکیبایی شما سپاسگزاریم"
					);
				}
			})
			.catch((error) => {
				Alert.error("در حال بروزرسانی هستیم، لطفا شکیبا باشید.");
			});

		Axios.get(`${Setting.apiUrl}api/application`).then((res) => {
			setApplication(res.data);
		});
		Axios.get(`${Setting.apiUrl}api/news/list`).then((res) => {
			setNews(res.data);
		});
		Axios.get(`${Setting.apiUrl}api/slider/list`).then((res) => {
			SetSlider(res.data);
		});

		changeActive(history.location.pathname.split("").splice(1).join(""));
	}

	// fetchChat = async () => {
	// 	try {
	// 		const data = await axios.get("https://admin.xitonix.com/api/chat/code");

	// 		const newCode = data.data.code.slice(31, -9);

	// 		const s = document.createElement("script");
	// 		s.type = "text/javascript";
	// 		s.async = true;
	// 		s.innerHTML = newCode;
	// 		this.instance.appendChild(s);
	// 	} catch (error) {
	// 		console.log(error);
	// 	}
	// };

	render() {
		let loggedIn = false;
		const { selectedProduct, checkoutRender, changeActive, nearest } =
			this.props;
		return (
			<>
				<div ref={(el) => (this.instance = el)} />
				<Switch>
					<Route
						exact
						path="/"
						component={Home}
					/>
					<Route
						path="/contact"
						component={ContactPage}
					/>
					<Route
						path="/suggestion"
						component={SuggestionPage}
					/>
					<Route
						path="/about"
						component={AboutUsPage}
					/>
					<Route
						exact
						path="/checkout"
						render={() => {
							if (checkoutRender.length) {
								return <CheckoutPage />;
							} else {
								changeActive("product");
								return <Redirect to="/product" />;
							}
						}}
					/>
					<Route
						path={`/news/:newsId`}
						component={SingleNewsLayout}
					/>
					<Route
						path="/terms"
						component={TermsPage}
					/>
					<Route
						path="/news"
						component={SingleNews}
					/>
					<Route
						exact
						path="/product"
						component={ProductPage}
					/>
					<Route
						exact
						path="/accessory"
						component={AccessoriesPage}
					/>
					<Route
						path="/product/singleProduct"
						render={() =>
							selectedProduct ? (
								<SingleProductPage />
							) : (
								<Redirect to="/product" />
							)
						}
					/>
					<Route
						path="/education"
						component={EducationPage}
					/>
					<Route
						path="/q"
						component={EducationPage}
					/>
					<Route
						path="/download"
						component={DownloadPage}
					/>
					<Route
						path="/login"
						component={LogInPage}
					/>
					<Route
						path="/agencies"
						component={AgenciesPage}
					/>
					<Route
						path="/representation"
						component={RepresentationPage}
					/>
					<Route
						path="/faq"
						component={FaqPage}
					/>
					<Route
						path="/specialFeatures"
						component={SpecialFeaturesPage}
					/>
					<Route
						path="/profile"
						render={() =>
							loggedIn ? <ProfilePage /> : <Redirect to="/login" />
						}
					/>
					<Route
						path="/map"
						component={MapPage}
					/>
					<Route
						path="/agency/:IMEI"
						component={AgencyPage}
					/>
					{/*<Route path='/map' render={()=> nearest ? <MapPage/>: <Redirect to='/agencies'/> }/>*/}
					<Route
						path="/callback/result"
						component={CallBackPage}
					/>
					<Route
						path="/onlinePay"
						component={OnlinePayPage}
					/>
					<Route component={Page404} />
				</Switch>
			</>
			//callback/result?track_code=58621539061
		);
	}
}

const mapStateToProps = createStructuredSelector({
	active: selectActiveLink,
	selectedProduct: selectSelectedProduct,
	checkoutRender: selectProduct,
	Loaded: selectLoaded,
	baseInfo: selectBaseInfo,
	nearest: selectNearest,
});
const mapDispatchToProps = (dispatch) => ({
	changeActive: (active) => dispatch(ChangeActiveLink(active)),
	setBaseInfo: (data) => dispatch(SetBaseInfo(data)),
	setApplication: (application) => dispatch(SetApplication(application)),
	setNews: (news) => dispatch(SetNews(news)),
	SetSlider: (Sdata) => dispatch(SetSlider(Sdata)),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
